import React from "react";
import { Box, CircularProgress } from "@mui/material";

const Loader = ({ size = 40 }) => {
	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				minHeight: "100px",
			}}
		>
			<CircularProgress
				size={size}
				sx={{
					color: "#c77c2f",
					"& .MuiCircularProgress-circle": {
						strokeLinecap: "round",
					},
				}}
			/>
		</Box>
	);
};

export default Loader;
